<template>
  <page-content-placeholder
    icon="assignment"
    prompt-text="No references"
  >
    <template #message>
      Once you have references in this category, they will appear
      here.
    </template>
  </page-content-placeholder>
</template>

<script>
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder';

export default {
  name: 'ScreenTabCompleteEmptyState',
  components: {
    PageContentPlaceholder,
  },
};
</script>
